import Vue from "vue";
import VueRouter from "vue-router";

/* Router Modules */
import annualRouter from "./modules/annual";
import idmRouter from "./modules/idm";
import staffRouter from "./modules/staff";
import qffileRouter from "./modules/qffile";
import releaseRouter from "./modules/release";

Vue.use(VueRouter);



const routes = [
	//考勤查询
	...annualRouter,
	//IDM
	...idmRouter,
	//员工资料表格
	...staffRouter,
	// 二维码受控管理文件
	...qffileRouter,
	// 放行审批
	...releaseRouter,
	{
		path: "/extra/system/invokelogin",
		name: "Invokelogin",
		component: () => import("@/views/system/invokelogin"),
		hidden: true,
		meta: {
			title: "认证登录"
		}
	},
	{
		path: "*",
		name: "error",
		component: () => import("@/views/error"),
		hidden: true
	}
];

const router = new VueRouter({
	routes
});

export default router;